import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum } from "__generated__/graphql";

export const SchemaRegistryLoaders: Partial<Record<AgreementTypeEnum, () => Promise<RegistryItem>>> = {
	[AgreementTypeEnum.BlockFreight]: () => import("./blockFreight.schema").then(r => r.BlockFreightSchema),
	[AgreementTypeEnum.BunkerAdjustment]: () => import("./bunkerAdjustment.schema").then(r => r.BunkerAdjustmentSchema),
	[AgreementTypeEnum.Commission]: () => import("./commission.schema").then(r => r.CommissionSchema),
	[AgreementTypeEnum.Daily]: () => import("./daily.schema").then(r => r.DailySchema),
	[AgreementTypeEnum.DangerousGood]: () => import("./dangerousGood.schema").then(r => r.DangerousGoodSchema),
	[AgreementTypeEnum.Deadfreight]: () => import("./deadfreight.schema").then(r => r.DeadfreightSchema),
	[AgreementTypeEnum.Demurrage]: () => import("./demurrage.schema").then(r => r.DemurrageSchema),
	[AgreementTypeEnum.DemurrageCalculation]: () => import("./demurrageCalculation.schema").then(r => r.DemurrageCalculationSchema),
	[AgreementTypeEnum.Feet]: () => import("./feet.schema").then(r => r.FeetSchema),
	[AgreementTypeEnum.Freight]: () => import("./freight.schema").then(r => r.FreightSchema),
	[AgreementTypeEnum.GasolinePrice]: () => import("./gasolinePrice.schema").then(r => r.GasolinePriceSchema),
	[AgreementTypeEnum.Gasoline]: () => import("./gasoline.schema").then(r => r.GasolineSchema),
	[AgreementTypeEnum.SupplementaryHeating]: () => import("./supplementaryHeating.schema").then(r => r.SupplementaryHeatingSchema),
	[AgreementTypeEnum.Hourly]: () => import("./hourly.schema").then(r => r.HourlySchema),
	[AgreementTypeEnum.Lumpsum]: () => import("./lumpsum.schema").then(r => r.LumpsumSchema),
	[AgreementTypeEnum.Oog]: () => import("./oog.schema").then(r => r.OogSchema),
	[AgreementTypeEnum.Pjk]: () => import("./pjk.schema").then(r => r.PjkSchema),
	[AgreementTypeEnum.Reefer]: () => import("./reefer.schema").then(r => r.ReeferSchema),
	[AgreementTypeEnum.Rent]: () => import("./rent.schema").then(r => r.RentSchema),
	[AgreementTypeEnum.Ship]: () => import("./ship.schema").then(r => r.ShipSchema),
	[AgreementTypeEnum.Teu]: () => import("./teu.schema").then(r => r.TeuSchema),
	[AgreementTypeEnum.Waterway]: () => import("./waterway.schema").then(r => r.WaterwaySchema),
	[AgreementTypeEnum.WaterLevel]: () => import("./waterLevel.schema").then(r => r.WaterLevelSchema),
	[AgreementTypeEnum.Weight]: () => import("./weight.schema").then(r => r.WeightSchema),
	[AgreementTypeEnum.WeightRange]: () => import("./weightRange.schema").then(r => r.WeightRangeSchema),
	[AgreementTypeEnum.AddressCommission]: () => import("./addressCommission.schema").then(r => r.AddressCommissionSchema),
	[AgreementTypeEnum.Text]: () => import("./text.schema").then(r => r.TextSchema),
	[AgreementTypeEnum.PostCalculation]: () => import("./postCalculation.schema").then(r => r.PostCalculationSchema),
	[AgreementTypeEnum.HoseRental]: () => import("./hoseRental.schema").then(r => r.HoseRentalSchema),
	[AgreementTypeEnum.NitrogenPurging]: () => import("./nitrogenPurging.schema").then(r => r.NitrogenPurgingSchema),
	[AgreementTypeEnum.Cleaning]: () => import("./cleaning.schema").then(r => r.CleaningSchema),
	[AgreementTypeEnum.MultiCargoAdjustment]: () => import("./multiCargoAdjustment.schema").then(r => r.MultiCargoAdjustmentSchema),
	[AgreementTypeEnum.MultiOrderAdjustment]: () => import("./multiOrderAdjustment.schema").then(r => r.MultiOrderAdjustmentSchema),
	[AgreementTypeEnum.ReturnFreightDiscount]: () => import("./returnFreightDiscount.schema").then(r => r.ReturnFreightDiscountSchema),
};

export async function loadSchema(type?: AgreementTypeEnum) {
	if (type == null) {
		return null;
	}

	const registryItem = await SchemaRegistryLoaders[type]?.();
	return registryItem?.[type];
}
